export const api = {
    roomSettings: (roomId: string) => `/api/rooms/${roomId}/settings/`
};

export const admin = {
    settings: (slug: string): string => `/administrator/rooms/${slug}/settings/`,
    setting: (slug: string, setting: string): string =>
        `/administrator/rooms/${slug}/settings/${setting}/`
};
